import { resetCurrentUser } from './useCurrentUser';
import { resetSelectedLocation } from './useSelectedLocation';
import { useNotificationStore } from './useNotificationStore';
import { useAuthState } from './useAuthState';
import { resetCartSession } from './useCartSession';

export async function resetSession(): Promise<void> {
  resetCurrentUser();
  resetSelectedLocation();
  resetCartSession();
  const { justLoggedIn } = useAuthState();
  justLoggedIn.value = false;
  await useNotificationStore().clearAll();
}
